import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

export type EmBlueHeroProps = {
  className?: string;
};

export const EmBlueHero = ({ className = '' }: EmBlueHeroProps) => {
  const { t } = useTranslation();
  // #004DBC
  return (
    <section
      className={`${className} h-auto lg:h-[580px] max-w-6xl m-auto px-3 py-2 lg:px-8 lg:py-10 text-left lg:text-left relative`}
    >
      <div className="z-40 relative h-full max-w-2xl">
        <h1 className="md__payments__title--h1">{t('EmBlueHero.title')}</h1>
        <p className="text-xl w-full lg:w-3/5 text-md-black font-thin">
          {t('EmBlueHero.description')}
        </p>
        <div className="flex ml-auto mt-14">
          <a
            className={clsx(
              'bg-md-purple hover:bg-md-purpleAlt bg-md-emblue hover:bg-md-emblue text-white hover:text-white active:text-white focus:text-white hover:no-underline active:no-underline focus:no-underline font-bold uppercase shadow-sm rounded-full py-0.5 lg:py-2 px-2 lg:px-6 text-lg'
            )}
            href={t('ProductsPublicPage.registerPathEmblue')}
            title={t('EmBlueHero.cta')}
          >
            <span className="hidden lg:block text-sm lg:text-lg">{t('EmBlueHero.cta')}</span>
            <span className="lg:hidden text-xs relative -top-0.5">
              {t('PublicHeader.Trial.titleShort')}
            </span>
          </a>
        </div>
      </div>

      <div className="md__products__hero__emblue absolute hidden lg:block bottom-0 left-0 right-0 top-0" />
    </section>
  );
};
